/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { phoneWirelessOffblack } from "../assets/phone-wireless-offblack";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconPhoneWirelessOffblack = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={phoneWirelessOffblack.svg} />
);

IllustrativeIconPhoneWirelessOffblack.displayName = "IllustrativeIconPhoneWirelessOffblack";
